import { Injectable } from '@angular/core';

export type E6bSide = 'calculator' | 'wind';
export type E6bWindScale = 'low' | 'high';

@Injectable({ providedIn: 'root' })
export class FlightComputerSession {
  /** Zoom is remembered independently per face. */
  zoomBySide: Record<E6bSide, number> = { calculator: 1, wind: 1 };
  /** Bumped when auto-fit logic changes so an old too-tight zoom is recomputed once. */
  windAutoZoomVersion = 0;
  side: E6bSide = 'wind';
  scale: E6bWindScale = 'low';

  get zoom(): number {
    return this.zoomBySide[this.side];
  }

  set zoom(value: number) {
    this.zoomBySide[this.side] = value;
  }
}
